import React, { useState, useEffect, useRef  } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ReactComponent as Coct } from '../assets/s-cockt.svg';
import { ReactComponent as Coll} from "../assets/s-col.svg";
import { ReactComponent as Co} from "../assets/s-cost.svg";
import { ReactComponent as Prop} from "../assets/s-prof.svg"
import { ReactComponent as More} from "../assets/s-more.svg";
import { ReactComponent as MonthlyIcon} from "../assets/mont-icon.svg";
import { ReactComponent as Clock} from "../assets/colck.svg";
import Chart from 'chart.js/auto';
import moment from 'moment';
import axios from 'axios';

const options = {
    maintainAspectRatio: false,
    // Add other options as needed
  };
const DatePickercom = ({uId, currencyDash}) => {
    const [selectedDateTimefrom, setSelectedDateTimefrom] = useState('');
    const [selectedDateTimeto, setSelectedDateTimeto] = useState('');
    const [data, setData] = useState([]);
    const [cocktails, setCocktails] = useState(0);
    const [collections, setCollections] = useState(0);
    const [cost, setCost] = useState(0);
    const [profit, setProfit] = useState(0);
    const [graphShow, setGraphShow] = useState(true);
    const [allColor, setAllColor] = useState(false);
    // const [userId, setUserId] = useState();
    const [userD, setUserD] = useState(null);
    const [macId, setMachineId] = useState();
    const handleDateTimeChange = (dateTime) => {
      
        setSelectedDateTimefrom(dateTime);
    };
    const handleDateTimeChangeto = (dateTime) =>{
        setSelectedDateTimeto(dateTime);
    }
    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed


    useEffect(() => {
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
      useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserD(userData);
            // Use userData as needed
        }
        // console.log(userDataString);
    }, []);
    useEffect(() => {
        setMachineId(userD ?.selectedMachineIds);
    }, [userD]);
    const postReport = async (e) => {
      e.preventDefault();
      setAllColor(false);
      // Check if selectedDateTimefrom and selectedDateTimeto are not empty
      if (!selectedDateTimefrom || !selectedDateTimeto) {
        alert('Please select both from and to dates');
        return;
      }
  
      // Convert selectedDateTimefrom and selectedDateTimeto to formatted dates
      // const formattedDatefrom = moment(selectedDateTimefrom).format('YYYY-MM-DD HH:mm:ss');
      // const formattedDateto = moment(selectedDateTimeto).format('YYYY-MM-DD HH:mm:ss');
      const formattedDatefrom = moment(selectedDateTimefrom)
        .local()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      const formattedDateto = moment(selectedDateTimeto)
        .local()
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
      // Check if formattedDatefrom is not greater than formattedDateto
      if (moment(formattedDatefrom).isAfter(formattedDateto)) {
        alert('From date should not be greater than to date');
        return;
      }
  
      // Check if formattedDatefrom and formattedDateto are not greater than current date
      if (moment(formattedDatefrom).isAfter(moment()) || moment(formattedDateto).isAfter(moment())) {
        alert('Selected dates should not be greater than current date');
        return;
      }
  
      const dataToSend = {
        from: formattedDatefrom,
        to: formattedDateto,
        user_id: uId,
        mId: macId
      };
      try {
        const response = await axios.post(
          '/api/fetch-reports',
          dataToSend,
          { withCredentials: true }
        );
        const data = response.data;
  
        if (data) {
          setCocktails(data[0].cocktails);
          setCost(data[0].COST);
          setProfit(data[0].PROFIT);
          setCollections(data[0].collections);
        } else {
          console.log('Response data is undefined');
        }
      } catch (error) {
        alert('Error fetching reports:', error);
        // Handle error
      }
    }


    const toggleGraph = () =>{
        setGraphShow(!graphShow)
    }
    const getAllSells = async ()=>{
      setAllColor(true);
        try {
          const response = await axios.post(
            '/api/sales-summary',
            { uId },
            { withCredentials: true }
          );
          const data = response.data;
          if (data) {
            setCocktails(data.cocktails);
            setCost(data.cost);
            setProfit(data.profit);
            setCollections(data.collection);
          } else {
            console.log('Response data is undefined');
          }
          // setSummary(response.data);
        } catch (error) {
          console.error('Error fetching sales summary:', error);
        }
    }

    const chartRef = useRef();
    const chartInstance = useRef(null);
  
    useEffect(() => {  
      fetchData();
    }, [uId]);

      const fetchData = async () => {
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        if (!userData || !userData.id) {
        throw new Error('User ID not found in session storage');
        }
        const userId = userData.id;
        const macId2 = userData.selectedMachineIds;
        try {
          const response = await axios.get(
            `/api/six-months-sell-price?uId=${userId}&macId=${macId2}`,
            { withCredentials: true }
          );
          const fetchedData = response.data;
  
          // Ensure that total_sell_price is not null, if null set it to 0
        const sanitizedData = fetchedData.map((item, index, array) => {
          // Check if total_sell_price is null, set it to 0
          const total_sell_price = item.total_sell_price !== null ? item.total_sell_price : 0;

          // Check if month is null and there is a valid month before it
          let month = item.month !== null ? moment(item.month).format('MMM YYYY') : 'no Record found';

          return { month, total_sell_price };
        });
  
          setData(sanitizedData);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };

  useEffect(() => {
      if (macId) {
          fetchData();
      }
  }, [macId]);
    useEffect(() => {
      const ctx = chartRef.current.getContext('2d');
    
      const labels = data.map(item => item.month);
    
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    
      const chartData = {
        labels: labels,
        datasets: [{
          label: 'Data',
          data: data.map(item => item.total_sell_price),
          backgroundColor: '#EF7C32',
          borderColor: '#EF7C32', // Change the graph line color
          borderWidth: 0
        }]
      };
    
      const options = {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              fontColor: '#EF7C32' // Set the text color for y-axis labels
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: '#EF7C32' // Set the text color for x-axis labels
            }
          }]
        }
        // Add other options as needed
      };
    
      chartInstance.current = new Chart(ctx, {
        type: 'bar',
        data: chartData,
        options: options
      });
    
      return () => {
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }
      };
    }, [data]);

      const margin =
  cost > 0
    ? (((collections - cost) / cost) * 100).toFixed(2)
    : "0.00";
    return (
        // <Container fluid>
      <div className='sp-recipes sp-report'>
    <div className={`${smallMedia ? 'collect-data-2' : 'collect-data'}`}>
    <div className={`${smallMedia ? 'upper-div-2' : 'upper-div' }`}>
    <div className={`${smallMedia ? 'clock-icon-2' : 'clock-icon'}`}>
    <Clock className="sp-icon sp-clock"/>
    </div>

        <div className={`${smallMedia ? 'inputs-div-2' : 'inputs-div' }`}>
        <div className={`${smallMedia ? 'dateRange-2' : 'dateRange'}`}>
        {/* <Col sm={12} md={6} lg={6}> */}
        <div className={`${smallMedia ? 'split-date-2' : 'split-date'}`}>
        <div className='date-h'>Date and Time range</div>

        <div className={`${smallMedia ? 'date-from-2' : 'date-from'}`}>
        <div className="triangle-container-date">
      <div className="shadeTriangle-date"></div>
      </div>
            <DatePicker 
                selected={selectedDateTimefrom}
                onChange={handleDateTimeChange}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="MMMM d, yyyy HH:mm"
                placeholderText="From"
                className={`${smallMedia ? 'pickerDD-2' : 'pickerDD'}`}
                wrapperClassName="date-picker-wrapper"
            />
        </div>
        <div className={`${smallMedia ? 'date-to-2' : 'date-to'}`}>
        <div className="triangle-container-date">
      <div className="shadeTriangle-date"></div>
      </div>
            <DatePicker 
                selected={selectedDateTimeto}
                onChange={handleDateTimeChangeto}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="MMMM d, yyyy HH:mm"
                placeholderText="To"
                className={`${smallMedia ? 'pickerDD-2' : 'pickerDD'}`}
                wrapperClassName="date-picker-wrapper"
            />
            {/* {selectedDateTimeto && <p>Selected date and time: {selectedDateTimeto.toLocaleString()}</p>} */}
        </div>
        </div>
        {/* </Col> */}
        </div>
        {/* <Col sm={12} md={6} lg={6}> */}
       <div className={`${smallMedia ? 's-list-2' : 's-list' }`}>
       <div className={`${smallMedia ? 'split-pic-2' : 'split-pic'}`}>
       <div className='date-h'>Minimal</div>
       <div className={`${smallMedia ? 'select-opt-2' : 'select-opt'}`}>
       <div className="triangle-container-date">
      <div className="shadeTriangle-date"></div>
      </div>
       <select className='box-opt'>
            <option className='opt'>All</option>
        </select>
       </div>
       <div className='allSlot' onClick={getAllSells} style={{backgroundColor: allColor ? '#EF7C32' : ''}}>
        <button className='allBtn' style={{color: allColor ? 'white' : ''}}>All</button>
       </div>
       </div>
       </div> 
       {/* </Col> */}
 </div>
</div>
<div className={`${smallMedia ? 'gn-btn-2' : 'gn-btn'}`}>
  <div className={`${smallMedia ? 'btn-generate-2' : 'btn-generate'}`} onClick={postReport}>
    <div className="triangle-container-date">
      <div className="shadeTriangle-dgbtn"></div>
      </div>
    <button className='gent-btn'> Generate  </button>
</div>
</div>
</div>

<div className='row row-cop'>
<Col sm={6} md={3} lg={3} style={{marginLeft: '-1.5%'}}>
        <div className={`small-contair ${smallMedia ? "small-contairsm" : ""}`}>
        <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
        <div className='cntr-txt'>
        {cocktails != null ? cocktails : 0 }
        </div>
        </div>
        <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
        <div className='cntr-txt plFl'>
            <div className='small-vv'>
            <Coct className='sp-icon'/>
            </div>
            <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cocktail</div>
            </div>
        </div>
        <div className='empty-div'>
        <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
        <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
        <button className='trans'>
        <p className="btnTxt">More info</p>
        <div className="btn-vec">
            <More className='vctr'/>
        </div>
        </button>
        </div>
        </div>
        </div>
    </div>
    </Col>
    <Col sm={6} md={3} lg={3}>
    <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
    <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
    <div className='cntr-txt'>
      {currencyDash}{cost != null ? cost.toFixed(2) : 0}
    </div>
    </div>
        <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
            
            <div className='cntr-txt plFl'>
            <div className='small-vv'>
            <Co className='sp-icon'/>
            </div>
            <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
            </div>
        </div>
        <div className='empty-div'>
        <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
        <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
        <button className='trans'>
        <p className="btnTxt">More info</p>
        <div className="btn-vec">
            
            <More  className='vctr' />
        </div>
        </button>
        </div>
        </div>
        </div>
    </div>
    </Col>
    <Col sm={6} md={3} lg={3}>
    <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
            <div className={`sm-co-t sm-co-t-sp ${smallMedia ? "sm-co-t2" : ""}`}>
            <div className='cntr-txt cntr-txt-sp'>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Profit</div><div>{currencyDash} {profit != null ? profit.toFixed(2) : "0.00"}</div> 
                </div>
                <div className='sub-cont-div-split'>
                    <div className='sp-span'>Margine</div><div>{margin}%</div> 
                </div> 
            </div>
            </div>
        {/* <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
           
            <div className='cntr-txt plFl'>
            <div className='small-vv'>
            <Co className="sp-icon" />
            </div>
            <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`}>Cost</div>
            </div>
        </div>  */}
        <div className='empty-div'>
        <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
        <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
        <button className='trans'>
        <p className="btnTxt">More info</p>
        <div className="btn-vec">
          
            <More className='vctr'/>
        </div>
        </button>
        </div>
    </div>
    </div>
    </div>
    </Col>
    <Col sm={6} md={3} lg={3} style={{marginRight: '-1.5%'}}>
    <div className={`small-contair ${smallMedia ? "small-contair2 small-contairsm" : ""}`}>
    <div className={`sm-co-t ${smallMedia ? "sm-co-t2" : ""}`}>
    <div className='cntr-txt'>
    {currencyDash}{collections != null ? collections.toFixed(2) : 0}
    </div>
    </div>
        <div className={`sm-co-v ${smallMedia ? "sm-co-v2" : ""}`}>
          
            <div className='cntr-txt plFl'>
            <div className='small-vv'>
            <Prop className="sp-icon"  />
            </div>
            <div className={`sm-co-n ${smallMedia ? "sm-co-n2" : ""}`} >Collection</div>
            </div>
        </div>
        <div className='empty-div'>
        <div className={`sm-co-bt ${smallMedia ? "sm-co-bt-s" : ""}`}>
        <div className={`sm-co-bt2 ${smallMedia ? "sm-co-bt2-s" : ""}`}>
        <div className={`shadeTriangle-sm ${smallMedia ? "shadeTriangle-sm2" : ""}`}></div>
        <button className='trans'>
        <p className="btnTxt">More info</p>
        <div className="btn-vec">
          
            <More className='vctr'/>
        </div>
        </button>
        </div>
        </div>
        </div>
    </div>
    </Col>
</div>

<div className='chart'>
    <div className={smallMedia ? 'shadeTriangle-graph' : 'shadeTriangle-graph2'} style={{display : graphShow ? "block" : "none"}}></div>
<div className='chart-head'>
    <div className='icon-cont' style={{display: smallMedia ? "none" : "block"}}>
      <MonthlyIcon  className="sp-icon" />
    </div>
    <div className='heading226'>
    Monthly Sales of Recipe
    </div>
    <div  className={` ${smallMedia ? "togle-grap" : "togle-grap-l"}`}  onClick={toggleGraph}>
        <div className='symbol'></div>
    </div>
</div>
<div style={{ width: '100%', height: '80%', fontSize : smallMedia ? '' : '2.60vh' ,display : graphShow ? "block" : "none" }} >
    <canvas ref={chartRef}> </canvas>
</div>
</div>

</div>
    );
};

export default DatePickercom;
